import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { SidebarTrigger } from '@/components/ui/sidebar';

type AppTopBarProps = {
  title: string;
  actions?: ReactNode;
};

export function AppTopBar({ title, actions }: AppTopBarProps) {
  const { t } = useTranslation('common');

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-border px-6 pt-1.5">
      <div className="flex items-center gap-4">
        <SidebarTrigger
          aria-label={t('topBar.toggleSidebar')}
          className="h-8 w-8 text-muted-foreground"
        />
        <div className="h-5 w-px bg-border" />
        <h1 className="text-sm font-medium">{title}</h1>
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </header>
  );
}
